import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import GitBtn from '../../Assets/Midia/github-black.svg';
import LinkedinBtn from '../../Assets/Midia/linkedin-black.svg';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import './local.css';

function Footer() {
    const { LNG } = useContext(DefaultContext)
    const openWebPage = (direct) => {
        if (direct === 'Git') window.open('https://github.com/guilhermedora', '_blank')
        else window.open('https://www.linkedin.com/in/guilhermedora/', '_blank')
    };
    return (
        <div className='footer-main-container'>
            <span className='title-footer'>
                {LNG ? ptbr.footer.item_1 : eng.footer.item_1}
            </span>
            <div style={Styles.midia}>
                <motion.div
                    style={{ marginRight: '1.5rem' }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1.01 }}
                    transition={{
                        duration: 1,
                        delay: 0.5,
                        ease: [0, 0.91, 0.2, 1.01],
                        scale: {
                            type: "spring",
                            damping: 10,
                            stiffness: 100,
                            restDelta: 0.001
                        }
                    }}
                    onClick={() => openWebPage("Linkedin")}
                >
                    <img
                        src={LinkedinBtn}
                        alt="Imagem"
                        style={{
                            width: '3rem', height: '3rem'
                        }}
                    />
                </motion.div>
                <motion.div
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1.01 }}
                    transition={{
                        duration: 1,
                        delay: 0.5,
                        ease: [0, 0.91, 0.2, 1.01],
                        scale: {
                            type: "spring",
                            damping: 10,
                            stiffness: 100,
                            restDelta: 0.001
                        }
                    }}
                    onClick={() => openWebPage("Git")}
                >
                    <img
                        src={GitBtn}
                        alt="Imagem"
                        style={{
                            width: '3rem', height: '3rem'
                        }}
                    />
                </motion.div>
            </div>
        </div>
    );
}

const Styles = {
    mainContainer: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        bottom: 0,
        width: '100%',
        height: '10vh',
        backgroundColor: '#263238'
    },
    bodyTxt: {
        fontSize: '1.8rem',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        letterSpacing: '0.05rem',
        lineHeight: '1.5',
        textAlign: 'right',
        color: '#EEFFB2',
        zIndex: 100
    },
    midia: {
        display: 'flex',
        alignItems: 'center'
    },
}

export default Footer;